import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Select from "react-select";
import fileDownload from "js-file-download";
import * as blobUtil from "blob-util";
import { ClipLoader } from "react-spinners";
import { formatShippingDate } from "../../../utils/shipping-date";

class ReportsSearchList extends React.Component {
  onExport = () => {
    const ids = this.state.reports.filter(r => r.isSelected).map(r => r.id);

    if (ids.length > 0) {
      this.setState({ isDownloading: true, error: undefined });

      this.props
        .getReportExport(ids)
        .then(r => {
          fileDownload(r.data.exportReport.base64, `export_${moment().format("YYYYMMDDkkmmss")}.csv`);
          this.setState({ isDownloading: false });
        })
        .catch(e => {
          console.log(e);
          this.setState({ isDownloading: false, error: "Error while downloading export" });
        });
    } else {
      this.setState({ error: "Please select at least one report!" });
    }
  };

  constructor(props) {
    super(props);
    console.log(props);
    this.state = {
      reports: this.initReports(props.reports || []),
      exportAll: false,
      isDownloading: false,
      error: undefined,
      canExport: !!this.props.getReportExport,
      isLoadingReport: false
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      reports: this.initReports(nextProps.reports || []),
      canExport: !!nextProps.getReportExport && this.props.USER_ROLE === "admin"
    });
  }

  onSelectReport = report => {
    const reports = this.state.reports;

    const r = reports.find(re => re.id === report.id);
    r.isSelected = !r.isSelected;

    this.setState({ reports });
  };

  initReports = reports => {
    return reports.map(r => {
      return {
        ...r,
        isSelected: false
      };
    });
  };

  onExportAllSelected = () => {
    const exportAll = !this.state.exportAll;

    const reports = this.state.reports;
    reports.forEach(r => (r.isSelected = exportAll));

    this.setState({
      exportAll,
      reports
    });
  };

  renderLoadingIndicator = () => {
    const { t } = this.props;
    return (
      <div v-if="isSearching" className="element-info-with-icon">
        <div className="element-info-icon">
          <div className="os-icon os-icon-grid-18 element-info-rotate"></div>
        </div>
        <div className="element-info-text">
          <h5 className="element-inner-header">{t("report.loading_reports")}</h5>
          <div className="element-inner-desc">{t("general.please_wait_data_from_cedoon")}</div>
        </div>
      </div>
    );
  };

  showReport = report => {
    this.props.showExternalReport(
      report.id,
      report.sheets.map(s => s.id),
      report.secret
    );
  };

  renderList = () => {
    const { t } = this.props;
    return (
      <div>
        {this.props.canExport ? (
          <div className="row">
            <div className="col-12">
              <div>
                {this.state.error ? (
                  <div className="alert alert-danger" role="alert">
                    {this.state.error}
                  </div>
                ) : (
                  undefined
                )}
              </div>
            </div>
          </div>
        ) : (
          undefined
        )}

        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                {this.props.canExport ? (
                  <th scope="col">
                    <input type={"checkbox"} onChange={this.onExportAllSelected} checked={this.state.exportAll} />
                  </th>
                ) : (
                  undefined
                )}
                <th style={{ lineBreak: "unset", minWidth: 130 }}>{t("report.report_no")}</th>
                <th>{t("report.description")}</th>
                <th>{t("report.customer")}</th>
                <th>{t("report.customer_order_no")}</th>
                <th>{t("report.sales_contract")}</th>
                <th>{t("report.shipping_date")}</th>
                <th>{t("report.data_validation")}</th>
                <th>{t("report.progress")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state.reports && this.state.reports.length > 0 ? (
                this.state.reports.map(report => {
                  return (
                    <tr key={report.id}>
                      {this.props.canExport ? (
                        <td>
                          <input
                            type={"checkbox"}
                            onChange={() => this.onSelectReport(report)}
                            checked={report.isSelected}
                          />
                        </td>
                      ) : (
                        undefined
                      )}
                      <td>{report.report_number}</td>
                      <td>{report.name}</td>
                      <td>{report.customer}</td>
                      <td>{report.customer_order_number}</td>
                      <td>{report.order_confirmation}</td>
                      <td>{formatShippingDate(report.shipping_date)}</td>
                      <td>
                        <div className="circle" validation={report.dataValidation}></div>
                      </td>
                      <td>
                        <div className="circle" progress={report.dataProgress}></div>
                      </td>
                      <td>
                        {this.props.printPdfDownloadKey ===
                        `${report.secret}-${report.sheets.map(s => s.id).join(",")}` ? (
                          <ClipLoader size={10} color={" #232f5d"} />
                        ) : (
                          <i
                            className="fas fa-eye"
                            style={{ cursor: "pointer" }}
                            onClick={() => this.showReport(report)}
                          ></i>
                        )}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center" }}>
                    <i>{t("reports_index.no_reports_found")}</i>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  render() {
    const { t } = this.props;
    if (this.props.isSearching || this.props.didSearch) {
      return (
        <div className="element-box" v-if="didSearch || isSearching">
          <div className="element-header">
            <h6>
              {t("reports_search_list.test_report_list")}
              {this.state.reports && this.state.reports.length > 0 ? ` (${this.state.reports.length} results)` : ""}
            </h6>
            {this.props.canExport ? (
              <button
                type="button"
                className="button"
                color="primary"
                rsize="medium"
                onClick={this.onExport}
                style={{ marginTop: -32, float: "right" }}
                disabled={this.state.isDownloading}
              >
                {this.state.isDownloading ? <ClipLoader size={10} color={"white"} /> : "Export selected"}
              </button>
            ) : (
              undefined
            )}
          </div>
          {this.props.isSearching ? this.renderLoadingIndicator() : this.renderList()}
        </div>
      );
    } else {
      return undefined;
    }
  }
}

const styles = {
  showButton: {
    cursor: "pointer"
  },
  error: {
    color: "red",
    marginBottom: "10px"
  }
};

export default ReportsSearchList;
